import PropTypes from 'prop-types';
import React from 'react';
import EventList from '../../../components/Events/EventList/EventList';
import EventsFilterHeader from '../../../components/Events/EventsFilterHeader/EventsFilterHeader';
import NoEventCard from '../../../components/Events/NoEventCard/NoEventCard';
import { componentTypes } from '../../../components/Includes/componentContentTypes';
import PageNav from '../../../components/JobComponents/Pagination/PageNav/PageNav';
import Layout from '../../../components/Layout/Layout';
import PageSection from '../../../components/Layout/PageSection/PageSection';
import RightRailContent from '../../../components/Layout/ThreeColumnGridLayout/RightRailContent/RightRailContent';
import ThreeColumnLayout from '../../../components/Layout/ThreeColumnLayout/ThreeColumnLayout';
import LeftRailContent from '../../../components/LeftRailLayout/LeftRailContent/LeftRailContent';
import { PAGE_PROPS as DefaultProps } from '../../defaultProps';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './EventCalendarLanding.scss';

export default class EventCalendarLanding extends React.PureComponent {
    render() {
        const {
            PAGE_PROPS,
            events,
            liveEvents,
            pagination: { prevUrl, nextUrl },
        } = this.props;
        const showPaginationBtn = prevUrl || nextUrl;
        const showNoEventCard = events.length === 0;
        const hideNonPublicFeatureFlag =
            PAGE_PROPS &&
            PAGE_PROPS.featureFlags &&
            PAGE_PROPS.featureFlags.eventsIsPublicOption;
        return (
            <div className="page-Events-EventCalendarLanding">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.EVENTS}
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                />
                <Layout PAGE_PROPS={PAGE_PROPS}>
                    <PageSection className="main-page-section" header="">
                        <ThreeColumnLayout>
                            <ThreeColumnLayout.LeftRail>
                                <LeftRailContent />
                            </ThreeColumnLayout.LeftRail>
                            <ThreeColumnLayout.MainContent>
                                <EventsFilterHeader />
                                <EventList
                                    events={events}
                                    liveEvents={liveEvents}
                                    hideNonPublicFeatureFlag={
                                        hideNonPublicFeatureFlag
                                    }
                                />
                                {showNoEventCard && <NoEventCard />}
                                {showPaginationBtn && (
                                    <PageNav
                                        prevUrl={prevUrl}
                                        nextUrl={nextUrl}
                                    />
                                )}
                            </ThreeColumnLayout.MainContent>
                            <ThreeColumnLayout.RightRail>
                                <RightRailContent
                                    contents={[
                                        componentTypes.SPONSORED_COMPANY,
                                        componentTypes.RECOMMENDED_CONNECTIONS,
                                    ]}
                                />
                            </ThreeColumnLayout.RightRail>
                        </ThreeColumnLayout>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}

EventCalendarLanding.defaultProps = {
    PAGE_PROPS: { url: { path: '/' } },
    events: [],
    liveEvents: [],
    pagination: {
        prevUrl: null,
        nextUrl: null,
    },
};

EventCalendarLanding.propTypes = {
    /**
     * Global props from the server
     */
    PAGE_PROPS: DefaultProps,
    /**
     * list of events that's going to be displayed on landing page
     */
    events: PropTypes.oneOfType([PropTypes.array]),
    /**
     * list of events that are happening live
     */
    liveEvents: PropTypes.oneOfType([PropTypes.array]),
    /**
     * url for previous & next page page
     */
    pagination: PropTypes.oneOfType([PropTypes.object]),
};
